<template>
    <label
        class="group/checkbox relative flex w-max select-none items-center hover:cursor-pointer">
        <input
            v-model="modelValue"
            type="checkbox"
            :disabled="disabled"
            :name="name"
            :value="value"
            class="peer sr-only" />
        <span
            :class="[
                { 'before:!bg-[#FF8686] after:!border-[#ff0000]': error },
                {
                    'group-hover/checkbox:after: group-hover/checkbox:before:bg-[#B591FC]':
                        !disabled,
                },
                { 'after:bg-accent': isChecked },
            ]"
            class="relative size-6 shrink-0 items-center justify-center p-1 before:absolute before:!size-4 before:bg-transparent before:transition-colors after:absolute after:inset-0 after:m-1 after:rounded-sm after:border-[1.5px]">
            <AtomIcon
                :class="{ 'opacity-0': !isChecked }"
                class="relative z-20 m-auto h-full transition-opacity duration-300"
                name="check"
                width="12"
                height="12" />
        </span>
        <span
            v-if="label"
            v-html="label"
            :class="error ? '!text-df353a' : ''"
            class="text-12/125 text-1f1c1c group-hover/checkbox:text-df353a ml-3 font-semibold transition-colors duration-200">
        </span>
        <span
            v-else
            :class="error ? '!text-df353a' : ''"
            class="text-12/125 text-1f1c1c group-hover/checkbox:text-df353a ml-3 font-semibold transition-colors duration-200">
            <slot />
        </span>
    </label>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

import AtomIcon from '~/components/atom/atom-icon/AtomIcon.vue'

const modelValue = defineModel({
    type: [Array, Boolean] as PropType<string[] | number[] | boolean>,
    required: true,
})

const props = defineProps({
    id: {
        /*
         * Уникальный идентификатор
         */
        type: String as PropType<string>,
        default: null,
    },
    name: {
        /*
         * Группа чекбоксов
         */
        type: String as PropType<string>,
        default: null,
    },
    value: {
        /*
         * Значение чекбокса
         */
        type: [String, Number, Boolean] as PropType<string | number | boolean>,
        default: null,
    },
    disabled: {
        /*
         * Управление состоянием включен / выключен
         */
        type: Boolean as PropType<boolean>,
        default: false,
    },
    label: {
        /*
         * Текст подписи к чекбоксу
         */
        type: String as PropType<string>,
        default: null,
    },
    error: {
        /*
         * Управление состоянием ошибки
         */
        type: Boolean as PropType<boolean>,
        default: false,
    },
})

const isChecked = computed(() => {
    return Array.isArray(modelValue.value)
        ? modelValue.value.some((value) => value === props.value)
        : modelValue.value
})
</script>
